import { QuestionAnswersModel } from './QuestionAnswersModel'

export class FeedbackAnalysisModel {
  public feedbackSummary: string | null = null
  public questionAnswers: QuestionAnswersModel[] | null = []
}
